import axios from "axios";

export class OAuthOpenIDDataSource {
    static path = "";

    static token(params) {
        const dataQueryStr = new URLSearchParams({
            client_id: process.env.REACT_APP_OAUTH_CLIENT_ID,
            client_secret: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
            redirect_uri: process.env.REACT_APP_OAUTH_BASE_URL + process.env.REACT_APP_OAUTH_URL_CALLBACK,
            grant_type: 'authorization_code',
            code_verifier: params.code_verifier,
            code: params.code
        })

        return axios
            .create({
                baseURL: process.env.REACT_APP_OAUTH_URL,
                headers: {    // can be common or any other method
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .post(process.env.REACT_APP_OAUTH_PATH_TOKEN, dataQueryStr)
    }

    static userInfo(params) {
        return axios
            .create({
                baseURL: process.env.REACT_APP_OAUTH_URL,
                headers: {    // can be common or any other method
                    'Authorization': `Bearer ${params.access_token}`,
                }
            })
            .get(process.env.REACT_APP_OAUTH_PATH_USERINFO)
    }
}
